import { Drawer } from "antd";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { MdClose, MdFlashOn } from "react-icons/md";
import Button from "shared/components/Button";
import Input from "shared/components/Input";
import Select from "shared/components/Select";
import { NAME_SPACES } from "shared/locales/constants";
import { CAMPAIGN_STATES } from "utils/api/graphql/queries/campaignStates";

const TerminateTaskDrawer = ({
  open,
  onClose,
  task,
  onTerminate,
  result,
  setResult,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.TASK);
  const DETAIL = t("DETAIL.TERMINATE_DRAWER", { returnObjects: true });
  return (
    <Drawer
      className="terminate-task-drawer"
      title={
        <div className="terminate-task-drawer__header">
          <h3>
            {DETAIL.CLOSE_TASK} : {get(task, "campaignStep.name", "")}{" "}
            <MdFlashOn />
          </h3>
          <button className="close-icon" onClick={onClose}>
            <MdClose />
          </button>
        </div>
      }
      open={open}
      onClose={onClose}
      closable={false}
      width={420}
    >
      <div className="terminate-task-drawer__content">
        <p className="terminate-task-drawer__subtitle">{DETAIL.TASK_RESULT}</p>

        <div className="terminate-task-drawer__form">
          <Select
            required
            type="async"
            defaultValue={get(task, "result.value")}
            node={{
              query: CAMPAIGN_STATES,
              variables: {
                where: {
                  type: "REMINDER",
                },
              },
              accessors: {
                root: "campaignStates.data",
                label: "state",
                value: "state",
              },
            }}
            placeholder={DETAIL.RESULT_PLACEHOLDER}
            label={DETAIL.RESULT_LABEL}
            onChange={(value) => setResult((prev) => ({ ...prev, value }))}
          />

          <Input
            type="textarea"
            label={DETAIL.COMMENT_LABEL}
            placeholder={DETAIL.COMMENT_PLACEHOLDER}
            defaultValue={get(task, "result.comment")}
            onChange={({ target: { value } }) =>
              setResult((prev) => ({ ...prev, comment: value }))
            }
            rows={4}
          />

          <Button
            type="success"
            onClick={() => onTerminate({ result, id: task.id })}
            block
            disabled={!result?.value}
          >
            {DETAIL.ACTION}
          </Button>
        </div>
      </div>
    </Drawer>
  );
};

export default TerminateTaskDrawer;
